import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '@orion-platform/core';
import { environment } from '@orion/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '../models/supply-visibility.model';
import { SVPredefinedComments } from '../models/sv-predefined-comments.model';
import { generateHttpParams, getUrl } from '../utils/general.utils';

@Injectable({
  providedIn: 'root',
})
export class SupplyVisibilityPredefinedCommentService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);

  private readonly mm = environment.modulesBaseUrl.materialManagement;
  private readonly baseUrl = this.config.getSettings('apiBaseUrl') as string;

  getSVCommentsByCategory(category: string): Observable<ApiResponse<SVPredefinedComments[]>> {
    const url = getUrl(this.baseUrl, this.mm.getSVPredefinedComment);

    const params = generateHttpParams({
      $skip: 0,
      $top: 100,
      category,
    });

    return this.http.get<ApiResponse<SVPredefinedComments[]>>(url, { params });
  }

  createSVPredefinedComment(comment: SVPredefinedComments): Observable<SVPredefinedComments> {
    const url = getUrl(this.baseUrl, this.mm.createSVPredefinedComment);
    return this.http.post<SVPredefinedComments>(url, comment);
  }

  updateSVPredefinedComment(comment: SVPredefinedComments): Observable<SVPredefinedComments> {
    const url = getUrl(this.baseUrl, this.mm.updateSVPredefinedComment);
    return this.http.put<SVPredefinedComments>(`${url}/${comment.id}`, comment);
  }

  deleteSVPredefinedComment(comment: SVPredefinedComments): Observable<string> {
    const url = getUrl(this.baseUrl, this.mm.deleteSVPredefinedComment);
    return this.http.delete(`${url}/${comment.id}`, { responseType: 'text' });
  }
}
